import {newsSlice} from '../../../reducers/runtime/news';

export const setFilterCollapsed = (value: boolean) => newsSlice.actions.setFilterCollapsed(value);

export const setFilterModalVisible = (value: boolean) => newsSlice.actions.setFilterModalVisible(value);
